import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApiData, getApiRecord } from 'services/DashboardService'

export const getData = createAsyncThunk('inventoryDashboard/data/getData', async data => {
    const response = await getApiData(data)
    return response.data
})

export const getRecord = createAsyncThunk('inventoryDashboard/data/getRecord', async id => {
    const response = await getApiRecord(id)
    return response.data
})

const recordData = {
    company: '',
    customer: '',
    report_url: '',
    grid: '',
    description: '',
    category: 'inventory',
}

const initialTableData = {
    category: 'inventory',
}

const dataSlice = createSlice({
    name: 'inventoryDashboard/data',
    initialState: {
        loading: false,
        view: recordData,
        data: [],
        tableData: initialTableData,
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.tableData = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
                state.tableData.total = 0
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload?.results
                state.tableData.total = payload?.count
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
            })
            .addCase(getRecord.fulfilled, (state, { payload }) => {
                state.loading = false
                state.record = payload
            })
            .addCase(getRecord.pending, state => {
                state.loading = true
                state.record = null
            })
            .addCase(getRecord.rejected, state => {
                state.loading = false
                state.record = null
            })
    },
})

export const { setData, setTableData } = dataSlice.actions

export default dataSlice.reducer
